import { createApp } from "vue";
import App from "./App.vue";
import axios from "axios";
import router from "./router";

const app = createApp(App);

// 配置axios全局属性
app.config.globalProperties.$http = axios;

// 使用路由
app.use(router);

// 挂载应用
app.mount("#app");
